import { render, staticRenderFns } from "./Botton.vue?vue&type=template&id=2a32cb8f&scoped=true&"
import script from "./Botton.vue?vue&type=script&lang=js&"
export * from "./Botton.vue?vue&type=script&lang=js&"
import style0 from "./Botton.vue?vue&type=style&index=0&id=2a32cb8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32cb8f",
  null
  
)

export default component.exports